var selectData = function (data) { return [
    {
        id: 1,
        title: data["1"]
    },
    {
        id: 2,
        title: data["2"]
    },
    {
        id: 3,
        title: data["3"]
    },
    {
        id: 4,
        title: data["4"]
    },
    {
        id: 5,
        title: data["5"]
    },
    {
        id: 6,
        title: data["6"]
    },
]; };
var formItem = function (data) { return [
    {
        id: 'name',
        placeholder: data.name,
        type: 'text',
        inputMode: 'text',
        input: true,
    },
    {
        id: 'phoneNumber',
        placeholder: data.phoneNumber,
        type: 'tel',
        inputMode: 'decimal',
        input: true,
    },
    {
        id: 'email',
        placeholder: data.email,
        type: 'email',
        inputMode: 'email',
        input: true,
    },
    {
        id: 'category',
        data: selectData(data.categoryData),
        placeholder: data.category,
        input: false,
    },
    {
        id: 'body',
        placeholder: data.body,
        type: 'text',
        inputMode: 'text',
        input: true,
        textInput: true,
        rows: 6,
    },
]; };
export { formItem, };
